<template>
  <div class="broadcast">
		<div class="header">
			<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4D/rB4ChmKyrp6AGutRAAALxM_JPcA420.png" />
			<div class="title">直播倒计时</div>
			<img class="icon1" src="https://img3.quanyou.com.cn/joy/group1/M00/12/4D/rB4ChmKyrp6AGutRAAALxM_JPcA420.png" />
		</div>
		<div class="time-box">
			05<span>天</span>
			20<span>时</span>
			11<span>分</span>
			11<span>秒</span>
		</div>
		<div class="button">立即预约</div>
	</div>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
	.broadcast {
		width: 269px;
		height: 119px;
		background: url('https://img3.quanyou.com.cn/joy/group1/M00/12/4E/rB4ChWKyrbiANJcLAADa8LMvqQo621.png');
		background-size: 100% 100%;
		margin: 0 auto;
		margin-top: 10px;
		overflow: hidden;
		.header {
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 18px;
			color: #FFFDF9;
			margin-top: 5px;
			.title {
				margin: 0 10px;
			}
			.icon1 {
				width: 13px;
				height: 13px;
			}
		}
		.time-box {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #FFFFFF;
			font-size: 21px;
			font-weight: 400;
			margin-top: 20px;
			span {
				font-size: 9px;
				margin: 5px 5px 0 5px;
			}
		}
		.button {
			width: 81px;
			height: 22px;
			color: #FE5F4F;
			font-size: 12px;
			text-align: center;
			line-height: 22px;
			background: #FFDFA0;
			border-radius: 11px;
			margin: 10px auto;
		}
	}
</style>